import { Popup, PopupActions, PopupContent, PopupHeading, } from "@/react/components/Common/Popup";
import React from "react";
import { Trans } from "react-i18next";
import Button from "@mui/material/Button";
const PictureRetouchInformationDialog = ({ picture, onClose, }) => {
    return (React.createElement(Popup, { onClose: onClose },
        React.createElement(PopupHeading, null,
            React.createElement(Trans, null, "Retouch service")),
        React.createElement(PopupContent, null,
            picture.userRetouchTasks && (React.createElement("ul", null, picture.userRetouchTasks.map((rt) => {
                return React.createElement("li", { key: rt.uuid }, rt.name);
            }))),
            !picture.userRetouchTasks && (React.createElement("div", null,
                React.createElement(Trans, null, "No retouch options set")))),
        React.createElement(PopupActions, null,
            React.createElement(Button, { variant: "contained", color: "primary", onClick: onClose },
                React.createElement(Trans, null, "Close")))));
};
export default PictureRetouchInformationDialog;
